
import { ComponentInternalInstance, defineComponent, watch, getCurrentInstance } from 'vue'
import { defineRule, useField } from 'vee-validate'
import { required, email } from '@vee-validate/rules'
import { useI18n } from 'vue-i18n'

defineRule('required', required)
defineRule('email', email)
export default defineComponent({
  props: {
    modelValue: {
      type: String
    },
    label: {
      type: String,
      default: 'formularios.email.label'
    },
    placeholder: {
      type: String,
      default: 'formularios.email.placeholder'
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const instance = getCurrentInstance() as ComponentInternalInstance;
    const {
      value: field,
      errorMessage,
      meta
    } = useField(
      'input-' + instance.uid.toString(),
      {
        required: props.required,
        email: true
      },
      {
        initialValue: props.modelValue,
        label: t(props.label).toString().toLowerCase()
      }
    )

    watch(field, val => emit('update:modelValue', val))
    return {
      t,
      field,
      errorMessage,
      meta
    }
  }
})
